import { Button, Container, Grid, Typography, Checkbox } from "@mui/material"
import React, { useState } from "react"
import { useAuthContext } from "../services/auth"
import { UserRole } from "../services/auth/auth.types"
import { useSnackbarContext } from "../services/snackbar"
import { httpClient } from "../services/http"
import { FieldContainer, PageTitle, StyledTextField } from "../components/StyledElements"
import { useNavigate } from "react-router-dom"
import { useStaticContext } from "../services/static"

export const AddPlaylist = (): React.ReactElement => {
  const [title, setTitle] = useState<string>("")
  const [description, setDescription] = useState<string>("")
  const [isPublic, setPublic] = useState<boolean>(false)

  const { role } = useAuthContext()
  const { open: sbOpen } = useSnackbarContext()
  const navigate = useNavigate()
  const { reloadPlaylists } = useStaticContext()

  const flushForm = () => {
    setTitle("")
    setDescription("")
    setPublic(false)
  }

  const handleSubmit = async () => {
    const data = {
      title: title,
      description: description,
      isPublic: isPublic,
    }

    try {
      await httpClient.instance.post("playlists", data, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      flushForm()
      sbOpen("Playlist créée avec succès", "success")
    } catch (error) {
      sbOpen("Erreur pendant la création de la playlist", "error")
    } finally {
      reloadPlaylists()
      navigate("/playlists")
    }
  }

  return (
    <>
      <PageTitle>{"Créer une playlist"}</PageTitle>
      <Container maxWidth="xl">
        <Grid container direction="row">
          <FieldContainer size={12}>
            <StyledTextField
              label="Titre"
              variant="standard"
              color="soft"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              autoFocus
              focused
            />
          </FieldContainer>
          <Grid size={{ xs: 12, md: 6 }} container direction="row">
            <FieldContainer size={12}>
              <StyledTextField
                label="Description"
                variant="outlined"
                color="soft"
                type="text"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                multiline
                minRows={8}
                maxRows={12}
                focused
              />
            </FieldContainer>
          </Grid>
          <Grid size={{ xs: 12, md: 6 }} container direction="row">
            {role === UserRole.GEEK && (
              <FieldContainer size={12}>
                <Checkbox checked={isPublic} color="soft" onChange={(e) => setPublic(e.target.checked)} />
                <Typography variant="body1" component="span">
                  {"Featuré"}
                </Typography>
              </FieldContainer>
            )}
            <FieldContainer size={12}>
              <Button variant="contained" color="secondary" onClick={handleSubmit} disabled={title === ""}>
                {"Valider"}
              </Button>
            </FieldContainer>
          </Grid>
        </Grid>
      </Container>
    </>
  )
}
